import { conversionStringJson } from "./utiles_objetos";

//cuentas bancarias
export class CuentasBancarias {
    constructor({
      tipoCuenta = "",
      numeroCuenta = "",
    } = {}){
      this.tipoCuenta = tipoCuenta;
      this.numeroCuenta = numeroCuenta;
    }
  
    static fromJson(json){
  
      return new CuentasBancarias({
        tipoCuenta: json['tipoCuenta'] || '',
        numeroCuenta: json['numeroCuenta'] || '',
      });
  
    }

    toJson(){
      return{
        'tipoCuenta': this.tipoCuenta,
        'numeroCuenta': this.numeroCuenta,
      }
    }

    toMap(){
      return{
        'tipoCuenta': this.tipoCuenta,
        'numeroCuenta': this.numeroCuenta,
      }
    }

    updateFromJson(updateData){
      if (!updateData || typeof updateData !== 'object') {
        console.warn('updateData debe ser un objeto válido en tutores');
        return;
      }

       Object.keys(updateData).forEach(field => {
        const value = updateData[field];

        switch(field) {

          case'tipoCuenta':
            this.tipoCuenta = conversionStringJson(value, this.tipoCuenta);
            break;

          case'numeroCuenta':
            this.tipoCuenta = conversionStringJson(value, this.numeroCuenta);
            break;

          default:
            console.warn(`Campo desconocido en update data de tutores: ${field}`);
            break;
        }

      });

    }

  }